import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import store from './store/index'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home
        },
        {
            path: '*',
            name: 'error',
            component: () => import('./views/NotFound.vue')
        }
    ],
    scrollBehavior (to) {
        if (to.hash != '') {
            return { x: 0, y: document.getElementById(to.hash.substring(1)).offsetTop }
        } else {
            return { x: 0, y: 0 }
        }
    }
})

// close the nav when page changes
router.beforeEach((to, from, next) => {

    // make sure the phase updates
    store.state.app.promotion.setPhases();

    store.dispatch('app/closeMobileNav');
    next();
});

export default router;